import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { AppState } from 'app/state/app.state';
import { map, tap } from 'rxjs';
import { ProductContextType } from '../../shared/models';

export type ThemeName = 'petrol' | 'lavender' | 'cx' | 'custom';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  store = inject<Store<AppState>>(Store<AppState>);
  private storeTheme = toSignal(this.store.select(s => s.companyContext?.productContext?.key).pipe(
    map((p: ProductContextType): ThemeName => {
      switch (p) {
        case ProductContextType.EX:
          return 'petrol'

        case ProductContextType.CX:
          return 'cx'

        case ProductContextType.Kiwi:
          return 'lavender'

        case ProductContextType.Custom:
          return 'custom'

        default:
          return 'petrol'

      }
    })
  ));

  private overrideTheme = signal<ThemeName>(null);

  readonly effectiveTheme = computed<ThemeName>(() => this.overrideTheme() ?? this.storeTheme());
  ef = effect(() => {
    const t = this.effectiveTheme();
    if (!t) return;
    this.applyToRoot(t);
  });


  setTheme(t: ThemeName) {
    this.overrideTheme.set(t);
  }

  resetToStoreTheme() {
    this.overrideTheme.set(null);
  }

  hasOverride(): boolean {
    return this.overrideTheme() !== null;
  }

  applyScopedTheme(container: HTMLElement, theme: ThemeName) {
    container.setAttribute('data-theme', theme);
  }

  clearScopedTheme(container: HTMLElement) {
    container.removeAttribute('data-theme');
  }


  private applyToRoot(theme: ThemeName) {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);

  }

}
